import { useEffect, useState } from "react"
import { Outlet, useLocation } from "react-router-dom"
import Sidebar from "../sidebar/Sidebar"
import ClaimedOrdersBanner from "../ClaimedOrdersBanner"
import AutoLinkedIlokBanner from "../AutoLinkedIlokBanner"
import { GenerateCodesModalProvider } from "../GenerateCodesModal"
import nfa_logo_with_name from "../../assets/nfa_logo_with_name.png"

export default function Layout() {
  const [drawerOpen, setDrawerOpen] = useState(false)
  const location = useLocation()

  useEffect(() => {
    setDrawerOpen(false)
  }, [location.pathname])

  return (
    <GenerateCodesModalProvider>
      <div className={`app-layout${drawerOpen ? " app-layout-drawer-open" : ""}`}>
        <header className="app-mobile-topbar">
          <button
            type="button"
            className="app-hamburger"
            aria-label={drawerOpen ? "Close menu" : "Open menu"}
            aria-expanded={drawerOpen}
            onClick={() => setDrawerOpen((v) => !v)}
          >
            <span />
            <span />
            <span />
          </button>
          <img src={nfa_logo_with_name} alt="NFA" className="app-mobile-logo" />
        </header>
        <div
          className="app-backdrop"
          onClick={() => setDrawerOpen(false)}
          aria-hidden="true"
        />
        <Sidebar />
        <div className="app-main">
          <div className="app-content">
            <ClaimedOrdersBanner />
            <AutoLinkedIlokBanner />
            <Outlet />
          </div>
        </div>
      </div>
    </GenerateCodesModalProvider>
  )
}
